// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { UserView, UserViewSchema } from 'api/gen/UserView';

const requiredPart = t.interface({
  content: t.union([t.array(UserViewSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelUserViewSchema = excess(requiredPart);

export interface PagedModelUserView extends t.TypeOf<typeof PagedModelUserViewSchema> {}
